import { defineMessages } from '../../i18n/messages';
import { englishText } from '../../utils/messageFallbacks';

const PRICING_PAGE_DEFINITIONS = {
  HEADING: {
    id: 'pricing.page.heading',
    text: 'AI Localization Pricing',
    description: 'The h1 of the /pricing page, above the plan comparison. "AI" is artificial intelligence; "localization" is the practice of adapting software to other languages.',
  },
  LEDE: {
    id: 'pricing.page.lede',
    text: 'Pay for words, not seats. Every plan ships the same product — all 56 locales, unlimited storage, the free CLI and full API access. The only thing that changes between tiers is how many words you can translate.',
    description: 'Lead paragraph under the pricing h1. States that tiers differ only by word allowance. "Seats" means per-user licences. "CLI" is Command Line Interface. "API" is the REST interface.',
  },
  LEDE_FREE: {
    id: 'pricing.page.lede_free',
    text: 'Start on the free plan with 5,000 words and no credit card. Paid plans are billed annually and you can cancel anytime.',
    description: 'Second lead paragraph under the pricing h1, covering the free tier and billing terms. "5,000 words" is the free allowance.',
  },
};

export const PricingPageMessages = defineMessages(PRICING_PAGE_DEFINITIONS);

/** English fallbacks, used until `npm run i18n:extract` adds these ids to en-US.json. */
export const PricingPageText = englishText(PRICING_PAGE_DEFINITIONS);
